import { render, staticRenderFns } from "./NewClaim.vue?vue&type=template&id=4a899d92&scoped=true&"
import script from "./NewClaim.vue?vue&type=script&lang=js&"
export * from "./NewClaim.vue?vue&type=script&lang=js&"
import style0 from "./NewClaim.vue?vue&type=style&index=0&id=4a899d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a899d92",
  null
  
)

export default component.exports